export default "__VITE_ASSET__CAaRqBSt__"